(() => {
  const selector = '[data-product-upsell-buy-now]';

  const setButtonState = (button, label, isLoading) => {
    const text = button.querySelector('span');
    if (text && label) text.textContent = label;
    button.disabled = isLoading;
    button.classList.toggle('is-loading', isLoading);
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest(selector);
    if (!button) return;

    const form = button.closest('form');
    if (!form) return;

    event.preventDefault();

    const originalLabel = button.querySelector('span')?.textContent || 'Buy now';
    setButtonState(button, 'Adding...', true);

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' }
      });

      if (!response.ok) throw new Error(`Cart add failed: ${response.status}`);

      window.location.href = button.dataset.upsellUrl || '/pages/checkout-upsell';
    } catch (error) {
      console.warn('ElitePCS Buy Now could not add this product before upsell.', error);
      setButtonState(button, 'Try again', false);
      window.setTimeout(() => setButtonState(button, originalLabel, false), 1800);
    }
  });
})();
